import m from 'mithril'
import stream from 'mithril/stream'
import moment from 'moment'
import {
    Dialog,
    TextBox,
    TextArea,
    Editor,
} from 'components'
import classNames from 'classnames'
import DatePicker from 'components/datepick/mithril-datepicker.js'
import {
    PhotoUploader,
    MultiPhotosUploader,
} from 'components/uploader'


class CategoryEditComponent {
    constructor(vnode) {
        if (vnode.attrs.model == null || vnode.attrs.model == "") {
            this.model = {
                name:"",

            }
        }else{
            this.model = JSON.parse(vnode.attrs.model)
        }
    }
    save() {
        Dialog.close(this.model)
    }
    close(event) {
        this._close(event)
    }
    _close(value) {
        setTimeout(() => {
            Dialog.close(value)
            m.redraw()
        }, 200)
    }
    view(vnode) {
        return [m(".modal-dialog.modal-lg[role='document']", [
            m(".modal-content",
                [
                    m(".modal-header",
                        [
                            m("h5.modal-title", "編輯"),
                            m("button.close", {
                                onclick: (e) => {
                                    e.preventDefault()
                                    this.close()
                                }
                            },
                                m("span", m.trust("&times;"))
                            ),
                        ]
                    ),
                    m(".modal-body",
                        m(".row.w-100", [
                            m(".col-12.d-flex.justify-content-end.pb-3", [
                                this.languages.map((_language) => {
                                    return m("button.btn.btn-primary.btn-sm.mx-0.mx-md-1.my-1.my-md-0[type='button']", {
                                        class: classNames({
                                            "active": this.select == _language
                                        }),
                                        onclick: (e) => {
                                            e.preventDefault()
                                            this.select = _language
                                        }
                                    },
                                        [
                                            m("i.fa.fa-edit"),
                                            _language.name
                                        ]
                                    )
                                }),
                            ]),
                            m(".col-12", [
                                m(".form-group", [
                                    m("label.text-dark.mb-1", "新增第1排文字/字數約在10字元內/可不填寫"),
                                    [
                                        m(TextBox, {
                                            oninput: (e) => {
                                                this.model[this.select.id + '1'] = e.target.value
                                            },
                                            class: 'mt-0 form-control',
                                            value: this.model[this.select.id + '1'],
                                            type: 'text',
                                        })
                                    ]
                                ]),
                            ]),
                            m(".col-12", [
                                m(".form-group", [
                                    m("label.text-dark.mb-1", "新增第2排文字/字數約在10字元內/可不填寫"),
                                    [
                                        m(TextBox, {
                                            oninput: (e) => {
                                                this.model[this.select.id + '2'] = e.target.value
                                            },
                                            class: 'mt-0 form-control',
                                            value: this.model[this.select.id + '2'],
                                            type: 'text',
                                        })
                                    ]
                                ]),
                            ]),
                            m(".col-12", [
                                m(".form-group", [
                                    m("label.text-dark.mb-1", "新增第3排文字/字數約在20字元內/可不填寫"),
                                    [
                                        m(TextBox, {
                                            oninput: (e) => {
                                                this.model[this.select.id + '3'] = e.target.value
                                            },
                                            class: 'mt-0 form-control',
                                            value: this.model[this.select.id + '3'],
                                            type: 'text',
                                        })
                                    ]
                                ]),
                            ]),
                            m(".col-12", [
                                m(".form-group", [
                                    m("label.text-dark.mb-1", "新增連結/未填寫不會出現連結按鈕"),
                                    [
                                        m(TextBox, {
                                            oninput: (e) => {
                                                this.model.website = e.target.value
                                            },
                                            class: 'mt-0 form-control',
                                            value: this.model.website,
                                            type: 'text',
                                        })
                                    ]
                                ]),
                            ]),
                        ]),
                    ),
                    m(".modal-footer",
                        [
                            m("button.btn.btn-label.rounded", {
                                onclick: (e) => {
                                    e.preventDefault()
                                    this.close()
                                }
                            },
                                [m("i.fa.fa-times-circle"), "關閉"]
                            ),
                            m("button.btn.btn-primary[type='button']", {
                                onclick: (e) => {
                                    e.preventDefault()
                                    this.save()
                                }
                            },
                                [
                                    m("i.fa.fa-check-circle"), "確認"
                                ])
                        ],
                    )
                ]
            )
        ])]
    }
}

export default CategoryEditComponent
